import { errorMessages } from '~/constants/errorMessages.ts';
import { otpValues } from '~/constants/common.ts';
import { getAttemptsWord } from '~/store/utils.ts';
import { TOtpErrorPayload, TOtpPayload } from '~/store/otp-verification/types.ts';

export const createEmptyOtp = () => new Array(otpValues.otp).fill('');

export const normalizeOtpError = (error: TOtpErrorPayload | null | undefined): TOtpPayload => {
  const payload = error?.data ?? error ?? {};
  const normalizedErrorCode =
    payload.errorCode === undefined ? undefined : Number(payload.errorCode);

  return {
    ...payload,
    errorCode: Number.isNaN(normalizedErrorCode) ? undefined : normalizedErrorCode,
  };
};

export const getOtpErrorMessage = (attemptsLeft?: number) =>
  attemptsLeft === undefined
    ? errorMessages.FIELD_OTP
    : `Залишилось ${attemptsLeft} ${getAttemptsWord(attemptsLeft)}`;
